// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__7iPYg","dark":"BaseLayout_dark__gQiDY","light":"BaseLayout_light__zcPlZ"};